var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup865Red1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 127.2,
    height: 100,
    viewBox: "0 0 127.2 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_865",
    "data-name": "Group 865",
    transform: "translate(474.586 -147.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3986",
    "data-name": "Path 3986",
    d: "M-337,233.087c14.149,0,28.3.062,42.446-.032,5.383-.036,8.483,3.36,9.308,6.441a11.817,11.817,0,0,1,.422,3.007q.036,29.14.015,58.28a9.122,9.122,0,0,1-9.44,9.509c-7.274.038-14.548.01-21.822.01q-31.735,0-63.47,0c-4.75,0-8.323-2.588-9.423-6.847a11.188,11.188,0,0,1-.328-2.761q-.027-29.007-.006-58.014c0-4.79,2.7-8.346,7.079-9.361a13.611,13.611,0,0,1,3.038-.221Q-358.092,233.076-337,233.087Zm24.859,63.491a8.172,8.172,0,0,0-3.314-5.356,52.567,52.567,0,0,0-6.95-3.471c-2.052-.911-4.266-1.475-6.262-2.484-1.948-.985-3.021-5.016-2.091-6.963.107-.224.417-.345.548-.565,1.054-1.768,2.079-3.553,3.135-5.32a3.737,3.737,0,0,1,.845-1.064c1.314-1.009,2.1-3.905,1.209-5.324a2.332,2.332,0,0,1-.148-2.2,14.473,14.473,0,0,0-.679-10.24,5.276,5.276,0,0,0-4.347-3.481,1.808,1.808,0,0,1-1.005-.721,6.175,6.175,0,0,0-4.087-2.515c-3.945-.527-7.71.063-10.557,3.054-3.829,4.021-4.341,8.905-3.045,14.118a2.391,2.391,0,0,1,.008,1.546,4.684,4.684,0,0,0,1.289,5.9,2,2,0,0,1,.506.694c.757,1.487,1.238,3.215,2.311,4.415a6.494,6.494,0,0,1,1.506,4.536,4.37,4.37,0,0,1-2.89,4.58c-1.773.78-3.671,1.275-5.464,2.015a46.85,46.85,0,0,0-6.232,2.869,8.951,8.951,0,0,0-4.1,5.974Z",
    transform: "translate(-62.581 -62.712)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3987",
    "data-name": "Path 3987",
    d: "M-369.948,161.241h-2.158q-39.378,0-78.756-.012c-3.445,0-6.356.994-8.425,3.889a9.988,9.988,0,0,0-1.7,6.025q.013,28.137,0,56.273v1.7c-5.988.911-11.021-.12-13.109-6.052a9.2,9.2,0,0,1-.47-2.994q-.039-31.6-.014-63.191a9.123,9.123,0,0,1,9-9.273c.266-.011.532-.007.8-.007q42.438,0,84.876,0c4.824,0,8.532,2.592,9.463,6.925A47.931,47.931,0,0,1-369.948,161.241Z",
    transform: "translate(0 0)",
    fill: "#febaba"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup865Red1);
export default __webpack_public_path__ + "static/media/Group 865-red1.8ffb0b608baf337aac09f365fd7bfe6b.svg";
export { ForwardRef as ReactComponent };